/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, October 11th 2021, 1:47:49 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import { schemaBuilder, isWebHost, portNumberBaseSchema } from "lib/validation";
import { WritableModel } from "lib/schemas/abstract";

export enum ENCRYPTION_OPTIONS {
  ssl = "SSL",
  starttls = "TLS",
  none = "None",
}

export interface MailServer extends WritableModel<false> {
  name: string;
  sequence: number;
  smtp_port: number;
  smtp_host: string;
  smtp_user: string;
  smtp_pass: string;
  active: boolean;
  smtp_encryption: keyof typeof ENCRYPTION_OPTIONS;
  from_email?: string;
}

export const MailServerValidationSchema: schemaBuilder.SchemaOf<MailServer> = schemaBuilder.object().shape({
  id: schemaBuilder.number().positive().nullable(),
  name: schemaBuilder.string().required("Name is required."),
  sequence: schemaBuilder.number().optional().nullable(),
  smtp_host: schemaBuilder
    .string()
    .required("The host name is required")
    .test(
      "host-check",
      "Host name is invalid. Must be hostname e.g. example.com or IP host e.g. 192.168.0.1:8090",
      (v) => v && isWebHost(v)
    ),
  smtp_port: portNumberBaseSchema().required("Port Number is required").typeError("Port Number is required"),
  smtp_user: schemaBuilder.string().required("Mail Gateway User is required"),
  smtp_pass: schemaBuilder.string().required("Mail Gateway Password is required"),
  active: schemaBuilder.boolean().required(),
  smtp_encryption: schemaBuilder.mixed().oneOf(Object.keys(ENCRYPTION_OPTIONS)).required("Select Encryption Type"),
  from_email: schemaBuilder.string().optional().nullable(),
});
